// extracted by css-extract-rspack-plugin
export default {"modelItemLabel":"ModelItem-module__modelItemLabel__bzQFhw1"};